
import React from 'react'

const Stars = ({ maxStars, rating }) => {
  const stars = []
  for (let i = 1; i <= maxStars; i++) {
    const starClass = i <= rating ? 'jdgm-star jdgm--on' : 'jdgm-star jdgm--off'
    stars.push(<span key={i} className={starClass} />)
  }
  return stars
}

export default Stars
